import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import {
  Close as CloseIcon,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { setShowSubscriptionPlanDialog } from "src/redux/slices/AuthSlice";
import SubscriptionPlanContent from "./SubscriptionPlanContent";

const SubscriptionPlanDialog = () => {
  const dispatch = useDispatch();
  const showSubscriptionPlanDialog = useSelector(
    (state) => state.auth.showSubscriptionPlanDialog
  );
  
  // Check if this is a newly registered business (requires subscription)
  const isNewlyRegisteredBusiness = useSelector(
    (state) => state.auth.isNewlyRegisteredBusiness
  );
  

  /**
   * Handle dialog close
   * Only allow closing if NOT a newly registered business
   * New businesses must complete subscription before closing
   */
  const handleClose = () => {
    // Prevent closing for newly registered businesses
    if (isNewlyRegisteredBusiness) {
      return;
    }
    
    // Allow closing for existing businesses
    dispatch(
      setShowSubscriptionPlanDialog({
        show: false,
        businessId: null,
      })
    );
  };

  return (
    <Dialog
      open={showSubscriptionPlanDialog.show}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      // Disable backdrop click for newly registered businesses
      disableEscapeKeyDown={isNewlyRegisteredBusiness}
      sx={{
        zIndex: 1400,
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: "#f8f9fa",
        },
      }}
    >
      <DialogContent
        sx={{
          p: 0,
          position: "relative",
          height: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Close button - Only show for existing businesses */}
        {!isNewlyRegisteredBusiness && (
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              zIndex: 3,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.9)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        )}

        {/* Use SubscriptionPlanContent component */}
        <Box sx={{ flex: 1, overflow: "hidden" }}>
          <SubscriptionPlanContent
            businessId={showSubscriptionPlanDialog.businessId}
            currentPlanName={showSubscriptionPlanDialog.currentPlan}
            IsMaxView={false}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SubscriptionPlanDialog;
